// Extraction iso-fonctionnelle du dashboard Creator existant (aucune modification de
// comportement). La logique reste dans pages/Dashboard.jsx pour éviter toute duplication.
import Dashboard from "../pages/Dashboard";

export default function CreatorDashboard() {
  return <Dashboard />;
}
